import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import { ALL_CONVERSATIONS, ALL_NOTIFICATIONS, DEF_JAM_ORG_ID } from '@/mockData';
import { filterByOrg } from '@/mockData/common/demoFilters';
import { defJamThreadMessages, defJamThreads } from '@/mockData/def-jam/inboxThreads';
import { mockThreads, mockThreadMessages } from '@/mockData/inboxThreads';

/**
 * Returns demo inbox data (notifications + conversations + threads/messages).
 * In prod mode, returns empty arrays -- real data comes from Nylas hooks.
 */
export function useInboxData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();

  const initialNotifications = useMemo(
    () => (isDemo ? filterByOrg(ALL_NOTIFICATIONS, selectedOrgId) : []),
    [isDemo, selectedOrgId],
  );

  const initialConversations = useMemo(
    () => (isDemo ? filterByOrg(ALL_CONVERSATIONS, selectedOrgId) : []),
    [isDemo, selectedOrgId],
  );

  const initialThreads = useMemo(
    () =>
      isDemo
        ? selectedOrgId === DEF_JAM_ORG_ID
          ? defJamThreads
          : mockThreads
        : [],
    [isDemo, selectedOrgId],
  );

  const initialMessages = useMemo(
    () =>
      isDemo
        ? selectedOrgId === DEF_JAM_ORG_ID
          ? defJamThreadMessages
          : mockThreadMessages
        : [],
    [isDemo, selectedOrgId],
  );

  return { initialNotifications, initialConversations, initialThreads, initialMessages };
}
